<template>
  <div class="border">
    <div class="container px-space-sm py-space-md">
      <div class="highlight bg-secondary mb-space-sm"></div>
      <div class="row gx-0">
        <div class="col-md-8">
          <div class="mb-space-sm mb-md-0 text-start" tabindex="0" v-html="text"></div>
        </div>
        <div class="col-md-3 col-lg-4 ms-auto button-container">
          <NuxtLink
            :href="eBookUrl"
            class="btn px-space-md"
            :class="getBtnVariant"
            target="_blank"
            @click="handleButtonClick($event)"
          >
            <div class="d-flex justify-content-center align-items-center">
              <font-awesome-icon icon="download" class="me-space-xxs"></font-awesome-icon>
              <span>
                {{ btnText }}
              </span>
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VariantOption } from "~/types/types";

interface Props {
  text: string;
  eBookUrl: string;
  btnText: string;
  btnVariant?: VariantOption;
}

export interface EbookClickEventPayload {
  event: Event;
  url: string;
}

const emits = defineEmits<{
  /**
   *  Emitted when the Tab is clicked.
   */
  (e: "btn-click", eventData: EbookClickEventPayload): void;
}>();

const props = withDefaults(defineProps<Props>(), {
  btnVariant: "secondary"
});

const getBtnVariant = computed(() => {
  return `btn-${props.btnVariant}`;
});

const handleButtonClick = (event: Event) => {
  emits("btn-click", { event, url: props.eBookUrl });
};
</script>

<style lang="scss" scoped>
.highlight {
  height: 8px;
  width: 65px;
}
@media screen and (min-width: 768px) {
  .button-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
